import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";

import PageHead from "@/pages/Head";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import EventHead from "@/components/Events/EventHead";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import EventGrid from "@/components/Events/Events";
import BackToTop from "@/pages/backToTop";
import CalendarBanner from "@/components/Calendar-banner/CalendarBanner";

import EventData from "../../data/events.json";

const EventGridPage = () => {
  return (
    <>
      <PageHead title="Calendar - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <EventHead />
          <div className="rbt-counterup-area rbt-section-overlayping-top rbt-section-gapBottomHalf">
            <div className="container">
              <EventGrid
                isPagination={false}
                parentClass="event-grid-card"
                childClass="col-lg-4 col-md-6 col-12"
                getEvents={EventData}
                start={0}
                end={3}
              />
            </div>
          </div>
          <CalendarBanner />
          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default EventGridPage;
